@if ({user: user(), items: items$ | async, theme: themeMode$ | async, mode: menuMode$ | async, mobile: isMobile$ | async, available: menuAvailable$ | async}; as vm) {
  <button type="button" id="button-basic" data-sn-user-toggle
          class="nav-link dropdown-toggle d-flex align-items-center sn-user-toggle"
          [class.sn-user-toggle--bar]="variant() === 'bar'"
          aria-haspopup="true" [attr.aria-expanded]="open" aria-controls="sn-user-menu"
          [attr.aria-label]="'Account: ' + displayName(vm.user)" (click)="toggle()">
    <img class="login-part__avatar" alt="" [src]="avatar(vm.user)">
    <span class="ms-1 sn-user-toggle__name">Hello {{ displayName(vm.user) }}</span>
  </button>
  <ul id="sn-user-menu" class="dropdown-menu dropdown-menu-end sn-user-menu" [class.show]="open && variant() === 'bar'">
    @for (item of vm.items; track trackById($index, item)) {
      @if (item.type === 'divider') {
      <li class="dropdown-divider" role="separator"></li>
      }

      @if (item.type === 'link') {
      <li>
        @if (!item.external) {
        <a class="dropdown-item" [routerLink]="item.path" [queryParams]="item.queryParams">
          <i class="fa-fw sn-user-menu__icon" [class]="item.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>{{ item.label }}
        </a>
        }
        @if (item.external) {
        <a class="dropdown-item" [href]="item.href" target="_blank" rel="noopener noreferrer">
          <i class="fa-fw sn-user-menu__icon" [class]="item.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>{{ item.label }}
          <span class="visually-hidden"> (opens in a new tab)</span>
        </a>
        }
      </li>
      }

      @if (item.type === 'action') {
      <li>
        <button type="button" class="dropdown-item" (click)="run(item.action)">
          <i class="fa-fw sn-user-menu__icon" [class]="item.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>{{ item.label }}
        </button>
      </li>
      }

      @if (item.type === 'widget' && item.action === 'themeSwitcher') {
      <li class="theme-mode-group-wrapper">
        <div class="sn-user-menu__widget-label" [id]="'sn-widget-' + item.id">{{ item.label }}</div>
        <div class="theme-mode-group" role="group" [attr.aria-labelledby]="'sn-widget-' + item.id">
          <button type="button" class="theme-mode-btn" [class.active]="vm.theme === 'light'" [attr.aria-pressed]="vm.theme === 'light'"
                  (click)="setTheme('light', $event)"><i class="fa-regular fa-sun" aria-hidden="true"></i> Light</button>
          <button type="button" class="theme-mode-btn" [class.active]="vm.theme === 'dark'" [attr.aria-pressed]="vm.theme === 'dark'"
                  (click)="setTheme('dark', $event)"><i class="fa-regular fa-moon" aria-hidden="true"></i> Dark</button>
          <button type="button" class="theme-mode-btn" [class.active]="vm.theme === 'system'" [attr.aria-pressed]="vm.theme === 'system'"
                  (click)="setTheme('system', $event)"><i class="fa-solid fa-desktop" aria-hidden="true"></i> System</button>
        </div>
      </li>
      }

      <!-- Menu layout: a phone always gets the drawer, so the choice is offered on wider screens only. -->
      @if (item.type === 'widget' && item.action === 'menuMode' && !vm.mobile && vm.available) {
      <li class="theme-mode-group-wrapper">
        <div class="sn-user-menu__widget-label" [id]="'sn-widget-' + item.id">{{ item.label }}</div>
        <div class="theme-mode-group" role="group" [attr.aria-labelledby]="'sn-widget-' + item.id">
          <button type="button" class="theme-mode-btn" [class.active]="vm.mode === 'top'" [attr.aria-pressed]="vm.mode === 'top'"
                  (click)="setMenuMode('top', $event)"><i class="fa-solid fa-window-maximize" aria-hidden="true"></i> Top</button>
          <button type="button" class="theme-mode-btn" [class.active]="vm.mode === 'side'" [attr.aria-pressed]="vm.mode === 'side'"
                  (click)="setMenuMode('side', $event)"><i class="fa-solid fa-table-columns" aria-hidden="true"></i> Side</button>
        </div>
      </li>
      }
    }
  </ul>

}
